import type { ChipTone } from "@outpave/ds";
import StatusType from "enums/CardStatusType";

// Not in StatusType on purpose: that enum is the query vocabulary and the server has no SUSPENDED.
const SUSPENDED = "SUSPENDED";

// Falls through to neutral: an unrecognised status is unknown, not failed.
export const cardStatusTone = (status?: string | null): ChipTone => {
  switch (status) {
    case StatusType.ACTIVE:
      return "positive";
    case StatusType.ISSUED:
      return "brand";
    case StatusType.PENDING:
    case StatusType.FROZEN:
      return "info";
    case SUSPENDED:
      return "warning";
    case StatusType.CANCELED:
    case StatusType.CLOSED:
      return "negative";
    case StatusType.INACTIVE:
    default:
      return "neutral";
  }
};
